module.exports = __webpack_public_path__ + "static/media/intro3.fa9e2e6d.png";